import { computed } from 'vue';
import { globalStore } from 'src/stores/global-store';
import { checkRole } from 'src/views/admin/utils/role-check';
import { ClientRole } from '@cognitoforms/types/server-types/core/services/client-role';
import type { OrganizationAuditLogItemType } from '@cognitoforms/types/server-types/model/organization-audit-log-item-type';

export const useOrganizationAuditLog = (session) => {
	const isAvailableOnPlan = computed(() => globalStore.organization?.Plan?.AllowOrganizationAuditLog || !!session.value?.isSupportUser);

	const checkPermissions = (entityId: string = null, entityType: OrganizationAuditLogItemType = null) => {
		if (entityId && entityType) {
			switch (entityType) {
				case 'Form':
					return globalStore.forms[entityId]?.CanManageForm;
				case 'Folder':
					return globalStore.folders[entityId]?.CanManageFolder;
				case 'EntryView':
					const formId = entityId.split('-')[0];
					return globalStore.forms[formId]?.CanManageEntries;
				case 'User':
				case 'Organization':
				case 'Plan':
				case 'Integration':
					return checkRole(ClientRole.Administrator);
			}
		}
		// Otherwise, check global permission
		return checkRole(ClientRole.Administrator);
	};

	const canViewOrganizationAuditLog = computed(() => checkPermissions());

	const canViewOrganizationAuditLogForEntity = (entityId: string, entityType: OrganizationAuditLogItemType) => {
		return checkPermissions(entityId, entityType);
	};

	return {
		canViewOrganizationAuditLog,
		canViewOrganizationAuditLogForEntity,
		isAvailableOnPlan
	};
};

export type OrganizationAuditLog = ReturnType<typeof useOrganizationAuditLog>;
